import { Modal, Text } from "@adoptaunabuelo/react-components";
import SectionContainer from "../../components/container/SectionContainer";
import Stripe from "stripe";
import { useStripe } from "@stripe/react-stripe-js";
import { bindActionCreators } from "@reduxjs/toolkit";
import { actionsCreators } from "../../redux";
import { useDispatch } from "react-redux";
import { useRef, useState } from "react";
import { ErrorScheme, Payment } from "client-v2";

const InfoView = (props: InfoViewProps) => {
	const stripe = useStripe();
	const dispatch = useDispatch();
	const { setShowError } = bindActionCreators(actionsCreators, dispatch);
	const modal = useRef<any>(null);
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [confirmUrl, setConfirmUrl] = useState<string | undefined>(undefined);
	const [paymentIntent, setPaymentIntent] = useState<
		Stripe.PaymentIntent | undefined
	>(undefined);

	window.addEventListener(
		"message",
		function (ev) {
			if (ev.data === "3DS-authentication-complete" && showModal) {
				modal.current.close();
			}
		},
		false
	);

	const onNextClick = async (paymentIntent: Stripe.PaymentIntent) => {
		setPaymentIntent(paymentIntent);
		if (paymentIntent.status === "requires_action") {
			if (paymentIntent.next_action) {
				//Confirm payment with Stripe SDK
				if (
					stripe &&
					paymentIntent.next_action.type === "use_stripe_sdk" &&
					paymentIntent.client_secret
				) {
					setLoading(true);
					const result = await stripe.confirmCardPayment(
						paymentIntent.client_secret
					);
					setLoading(false);
					if (result.error) {
						setShowError({
							show: true,
							message: result.error.message,
						});
					} else if (result.paymentIntent.status === "succeeded") {
						props.onFinish({ data: true });
					}
				}
				//Confirm payment with url
				else if (
					paymentIntent.next_action.type === "redirect_to_url" &&
					paymentIntent.next_action.redirect_to_url?.url
				) {
					setLoading(true);
					setConfirmUrl(
						paymentIntent.next_action.redirect_to_url.url
					);
					setShowModal(true);
				}
			}
		} else if (paymentIntent.status === "requires_confirmation") {
			confirmPaymentIntent(paymentIntent);
		} else props.onFinish({ data: true });
	};

	const confirmPaymentIntent = async (
		paymentIntent: Stripe.PaymentIntent
	) => {
		setShowModal(false);
		Payment.finishPaymentIntent(paymentIntent.id)
			.then((result) => {
				if (
					result.data.status === "succeeded" ||
					result.data.status === "processing"
				) {
					onPaymentIntentConfirmed();
				} else {
					onNextClick(result.data);
				}
			})
			.catch((error: ErrorScheme) => {
				onPaymentIntentConfirmed(error.message);
			});
	};

	const onPaymentIntentConfirmed = (error?: string) => {
		if (error) {
			setLoading(false);
			props.onFinish({
				error: error,
			});
		} else {
			setLoading(false);
			setSuccess(true);
		}
	};

	return (
		<SectionContainer
			buttonProps={{
				loading: loading,
				success: success,
				onClick: () => {
					if (props.subscription.status === "canceled") {
						window.open("/donacion");
					} else onNextClick(props.paymentIntent);
				},
				onSuccess: () => {
					setSuccess(false);
					props.onFinish({ data: true });
				},
				children:
					props.subscription.status === "canceled"
						? "Reactivar mi donación"
						: props.paymentIntent.status === "requires_action" ||
						  props.paymentIntent.status === "requires_confirmation"
						? "Confirmar pago"
						: "Actualizar método de pago",
			}}
		>
			<Modal
				type="web"
				contentStyle={{ padding: 0, height: "100%" }}
				ref={modal}
				isVisible={showModal}
				hideClose={true}
				hideHeader={true}
				url={confirmUrl}
				style={{ width: 600, height: "100%", padding: 0 }}
				onClose={() =>
					paymentIntent && confirmPaymentIntent(paymentIntent)
				}
			/>
			<Text type="h3" weight="semibold" style={{ textAlign: "center" }}>
				{props.paymentIntent.status === "canceled" ||
				props.subscription.status === "canceled"
					? "Tu donación se ha cancelado"
					: "No hemos podido completar tu donación"}
			</Text>
			<Text type="p" style={{ textAlign: "center", marginTop: 8 }}>
				{props.paymentIntent.status === "requires_action" ||
				props.paymentIntent.status === "requires_confirmation"
					? "Necesitamos que sigas formando parte de este proyecto para ayudar a más personas mayores. Solo tienes que confirmar el cargo para que tu donación siga activa."
					: props.subscription.status === "canceled"
					? "Parece que por algún error con tu método de pago, tu donación se ha cancelado. Necesitamos que sigas formando parte de este proyecto para ayudar a más personas mayores."
					: "Necesitamos que sigas formando parte de este proyecto para ayudar a más personas mayores. Solo necesitas actualizar tu método de pago. Es muy rápido, no te llevará más de un minuto."}
			</Text>
		</SectionContainer>
	);
};
export default InfoView;
export interface InfoViewProps {
	subscription: Stripe.Subscription;
	paymentIntent: Stripe.PaymentIntent;
	onFinish: (result: { data?: boolean; error?: string }) => void;
}
